(function ($, Cobalt, undefined) {
	Cobalt.CPUserProfileTitle =
    {
        initialize: function () {
    	    $(document).on("change", ".j-enable", function () {
    	        Cobalt.CPUserProfileTitle.handleCustomTitlePermissionEnableChange($(this));
    		});
    	},
    	handleCustomTitlePermissionEnableChange: function ($customTitlePermissionEnable) {
    	    if ($customTitlePermissionEnable.is(":checked")) {
    	        $customTitlePermissionEnable.closest("tr").find(".j-post-count-threshold").show();
    		} else {
    	        $customTitlePermissionEnable.closest("tr").find(".j-post-count-threshold").hide();
    		}
    	}
    };
})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPUserProfileTitle.js